import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const AdidasPerformanceHat = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[8].productName}
				color={product.allGear[8].color}
				size={product.allGear[8].sizes}
				price={product.allGear[8].price}
				img={product.allGear[8].img}
				miniImg1={product.allGear[8].miniImg1}
				miniImg2={product.allGear[8].miniImg2}
				miniImg3={product.allGear[8].miniImg3}
			/>
		</React.Fragment>
	);
};

export default AdidasPerformanceHat;
